import React, { useState,useEffect } from "react";
import { Button, FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";

const TiktokAdsModal = ({ isOpen, toggle, onSubmit, currentConfig }) => {
    const [formData, setFormData] = useState({
        name: currentConfig?.name || "",
        expireDate: currentConfig?.expireDate || "",
        tiktokAccessToken: currentConfig?.config?.accessToken || ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        onSubmit(formData);
    };
    useEffect(() => {
        if (!isOpen) {
            setFormData({
                name: currentConfig?.name || "",
                expireDate: currentConfig?.expireDate || "",
                tiktokAccessToken: currentConfig?.config?.accessToken || ""
            });
        }
    }, [isOpen, currentConfig]);
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Create TikTok Account</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" value={formData.name} onChange={handleChange} required />
                </FormGroup>
                <FormGroup>
                    <Label for="expireDate">Expire Date</Label>
                    <Input type="date" name="expireDate" id="expireDate" value={formData.expireDate} onChange={handleChange} required />
                </FormGroup>
                <FormGroup>
    <Label for="tiktokAccessToken">Access Token</Label>
    <Input
        type="text"
        name="tiktokAccessToken"
        id="tiktokAccessToken"
        value={formData.tiktokAccessToken}
        onChange={handleChange}
        required
    />
</FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="success" onClick={handleSubmit}>Submit</Button>
            </ModalFooter>
        </Modal>
    );
};

export default TiktokAdsModal;

